// extracted by mini-css-extract-plugin
export var container = "PageBreadcrumbs-module--container--9724e";